import { Platform } from '.';
import getSiteHost from '../services/getSiteHost';
import { IUserInfo } from '../services/getUserInfo';
import { getLangSwitchList } from '@umu/umu-lang-switch';

const siteHost = getSiteHost();


function createPromiseCache<T>(fn: () => Promise<T>): () => Promise<T> {
    let cachePromise: Promise<T> | null = null;
    return function () {
        if (!cachePromise) {
            cachePromise = fn();
        }
        return cachePromise;
    };
}
/** header footer 只调用一次，避免重复请求 */
const getPageConfig = createPromiseCache(async () => {
    const url = '/napi/v1/home/get-page-data';
    const res = await fetch(url);
    const data = await res.json();
    if (data.error_message) {
        throw new Error(data.error_message);
    }
    return JSON.parse(data.data.config);
});

type InitHeaderProps = {
    isMobile: boolean;
    userInfo?: IUserInfo;
}
export const initHeader = async ({ isMobile, userInfo }: InitHeaderProps) => {
    const pageConfig = await getPageConfig();
    if (!pageConfig) return;
    const options = {
        platform: isMobile ? Platform.MOBILE : Platform.TWWW,
        siteHost,
        lang: LOCALE.toLowerCase(),
        langOptions: getLangSwitchList().map((e) => {
            return {
                text: e.value,
                val: e.key,
            };
        }),
        system: SYSTEM.toLowerCase(),
        isLogin: !!userInfo,
        userInfo: userInfo ? userInfo : undefined,
        headerData: pageConfig.header,
    };
    const headerRenderer = window.HomeHeader.render;
    /**
     * 注意：在应用到的页面html中，确保存在挂载对象，若不存在这手动加上相应标签
     */
    headerRenderer(options as any, document.querySelector('.page-header') as HTMLElement);
};

type InitFooterProps = {
    isMobile: boolean;
}
export const initFooter = async({ isMobile }: InitFooterProps) => {
    const footerRenderer = window.HomeFooter.render;
    const pageConfig = await getPageConfig();
    if (!pageConfig) return;

    /**
     * 注意：在应用到的页面html中，确保存在挂载对象，若不存在这手动加上相应标签
     */
    footerRenderer(
        {
            platform: isMobile ? Platform.MOBILE : Platform.TWWW,
            siteHost,
            lang: LOCALE.toLowerCase(),
            langOptions: getLangSwitchList().map((e) => {
                return {
                    text: e.value,
                    val: e.key,
                };
            }),
            system: SYSTEM.toLowerCase(),
            footerData: pageConfig.footer,
        },
        document.querySelector('.page-footer') as HTMLElement,
    );
};